import { render } from "./ActivityDrawer.vue?vue&type=template&id=0fe89c72"
import script from "./ActivityDrawer.vue?vue&type=script&lang=ts"
export * from "./ActivityDrawer.vue?vue&type=script&lang=ts"
script.render = render

export default script